(()=>{
  let requestController=null;
  let desktopFilterTimer=null;
  let lastFilterTrigger=null;

  const PREVIEW_PARAMS=['preview_theme_id','_ab','_fd','_sc'];
  const section=()=>document.querySelector('[data-collection-section]');
  const filterDrawer=()=>document.querySelector('[data-filter-drawer]');

  const disneyNav=()=>document.querySelector('[data-disney-character-nav]');

  function findDisneyCharacter(key){
    if(!key)return null;
    return Array.from(disneyNav()?.querySelectorAll('[data-disney-character-source]')||[])
      .find((card)=>card.dataset.disneyCharacterKey===key)||null;
  }

  function resolveDisneyCollection(target){
    const publicUrl=preserveThemeContext(new URL(target,window.location.origin));
    const nav=disneyNav();
    if(!nav||publicUrl.origin!==window.location.origin){
      return {publicUrl,sourceUrl:publicUrl,selected:null};
    }

    const base=new URL(nav.dataset.disneyBaseUrl,window.location.origin);
    if(publicUrl.pathname===base.pathname){
      publicUrl.searchParams.set('view','disney');
      const selected=findDisneyCharacter(publicUrl.searchParams.get('disney_character'));
      if(!selected){
        publicUrl.searchParams.delete('disney_character');
        return {publicUrl,sourceUrl:publicUrl,selected:null};
      }

      const sourceUrl=new URL(selected.dataset.disneyCharacterSource,window.location.origin);
      if(sourceUrl.origin!==window.location.origin){
        publicUrl.searchParams.delete('disney_character');
        return {publicUrl,sourceUrl:publicUrl,selected:null};
      }
      publicUrl.searchParams.forEach((value,key)=>{
        if(key!=='disney_character')sourceUrl.searchParams.append(key,value);
      });
      sourceUrl.searchParams.set('view','disney');
      return {publicUrl,sourceUrl,selected};
    }

    const current=new URL(window.location.href);
    const active=findDisneyCharacter(current.searchParams.get('disney_character'));
    if(active){
      const activeSource=new URL(active.dataset.disneyCharacterSource,window.location.origin);
      if(publicUrl.pathname===activeSource.pathname){
        publicUrl.searchParams.set('view','disney');
        const disneyPublicUrl=new URL(base.href);
        publicUrl.searchParams.forEach((value,key)=>disneyPublicUrl.searchParams.append(key,value));
        disneyPublicUrl.searchParams.set('disney_character',active.dataset.disneyCharacterKey);
        return {publicUrl:disneyPublicUrl,sourceUrl:publicUrl,selected:active};
      }
    }

    return {publicUrl,sourceUrl:publicUrl,selected:null};
  }

  function updateDisneyFilterState(publicUrl,replacement){
    const nav=disneyNav();
    if(!nav)return;

    const selectedKey=publicUrl.searchParams.get('disney_character');
    const active=findDisneyCharacter(selectedKey);
    nav.querySelectorAll('[data-disney-character-source]').forEach((card)=>{
      const selected=card===active;
      card.classList.toggle('is-active',selected);
      if(selected)card.setAttribute('aria-current','true');
      else card.removeAttribute('aria-current');
    });

    const selectedType=active?null:publicUrl.searchParams.get('filter.p.product_type');
    document.querySelectorAll('[data-disney-type-filter]').forEach((card)=>{
      const selected=Boolean(selectedType&&selectedType===card.dataset.disneyTypeFilter);
      card.classList.toggle('is-active',selected);
      if(selected)card.setAttribute('aria-current','true');
      else card.removeAttribute('aria-current');
    });

    if(!active)return;
    const isArabic=nav.getAttribute('dir')==='rtl';
    const name=active.dataset.disneyCharacterLabel||active.textContent.trim();
    const heading=replacement.querySelector('.collection-page__title');
    if(heading)heading.textContent=isArabic?'تسوق '+name:name+' toys';
    const eyebrow=replacement.querySelector('.collection-page__eyebrow');
    if(eyebrow)eyebrow.textContent=isArabic?'شخصيات ديزني':'Disney character collection';

    const area=replacement.querySelector('.collection-page__heading');
    if(!area)return;
    const context=document.createElement('div');
    context.className='disney-filter-context';
    const text=document.createElement('span');
    text.textContent=isArabic?'المنتجات المعروضة: '+name:'Showing: '+name;
    const clear=document.createElement('a');
    const clearUrl=new URL(nav.dataset.disneyBaseUrl,window.location.origin);
    clearUrl.searchParams.set('view','disney');
    clear.href=preserveThemeContext(clearUrl).href;
    clear.dataset.collectionLink='';
    clear.textContent=isArabic?'عرض جميع ألعاب ديزني':'View all Disney toys';
    context.append(text,clear);
    area.appendChild(context);
  }


  function preserveThemeContext(url){
    const current=new URL(window.location.href);
    PREVIEW_PARAMS.forEach((key)=>{
      if(!url.searchParams.has(key)&&current.searchParams.has(key)){
        url.searchParams.set(key,current.searchParams.get(key));
      }
    });
    return url;
  }

  function setBodyLock(locked){
    document.documentElement.style.overflow=locked?'hidden':'';
    document.body.style.overflow=locked?'hidden':'';
  }

  function openFilters(button){
    const drawer=filterDrawer();
    if(!drawer)return;
    lastFilterTrigger=button||document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
    button?.setAttribute('aria-expanded','true');
    setBodyLock(true);
    requestAnimationFrame(()=>drawer.querySelector('.collection-filter-drawer__close')?.focus());
  }

  function closeFilters({restoreFocus=true}={}){
    const drawer=filterDrawer();
    if(!drawer)return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
    document.querySelector('[data-filter-drawer-open]')?.setAttribute('aria-expanded','false');
    setBodyLock(false);
    if(restoreFocus&&lastFilterTrigger&&document.contains(lastFilterTrigger))lastFilterTrigger.focus();
  }

  function formUrl(form){
    const url=preserveThemeContext(new URL(form.action,window.location.origin));
    const data=new FormData(form);
    data.forEach((value,key)=>{
      const normalized=String(value).trim();
      if(normalized!=='')url.searchParams.append(key,normalized);
    });
    return url;
  }

  function loading(active){
    const current=section();
    if(!current)return;
    current.classList.toggle('is-loading',active);
    current.setAttribute('aria-busy',active?'true':'false');
  }

  function placeDisneySeoAfterProducts(root){
    if(!disneyNav()||!root)return;
    const body=root.querySelector('.collection-page__body');
    const description=root.querySelector('.collection-page__heading > .collection-page__description');
    if(!body||!description)return;
    const existing=body.querySelector(':scope > div.collection-page__seo-content');
    if(existing){
      description.remove();
      return;
    }
    description.classList.remove('collection-page__description');
    description.classList.add('collection-page__seo-content');
    const heading=document.createElement('h2');
    heading.textContent=disneyNav().getAttribute('dir')==='rtl'?'عن مجموعة ألعاب ديزني':'About Disney Toys Collection';
    description.prepend(heading);
    const guides=body.querySelectorAll(':scope > section.collection-page__seo-content');
    if(guides.length)body.insertBefore(description,guides[0]);
    else body.appendChild(description);
  }

  function promoteDescriptionBanner(){
    const current=section();
    const seo=current?.querySelector('.collection-page__seo-content');
    if(!current||!seo)return;

    const image=seo.querySelector('img');
    if(!image)return;

    const source=image.closest('a')||image;
    const hasDedicatedBanner=Boolean(document.querySelector('.collection-banner'));

    if(!hasDedicatedBanner&&!document.querySelector('[data-description-banner]')){
      const banner=document.createElement('section');
      banner.className='collection-description-banner';
      banner.dataset.descriptionBanner='';
      banner.setAttribute('aria-label',image.alt||'Collection promotion');

      const inner=document.createElement('div');
      inner.className='page-width collection-description-banner__inner';
      const media=document.createElement('div');
      media.className='collection-description-banner__media';
      const clone=source.cloneNode(true);
      const cloneImage=clone.matches?.('img')?clone:clone.querySelector?.('img');
      if(cloneImage){
        cloneImage.removeAttribute('width');
        cloneImage.removeAttribute('height');
        cloneImage.loading='eager';
        cloneImage.fetchPriority='high';
      }
      media.appendChild(clone);
      inner.appendChild(media);
      banner.appendChild(inner);
      current.before(banner);
    }

    source.remove();
    if(!seo.querySelector('p,ul,ol,h3,h4,h5,h6,blockquote')){
      seo.remove();
    }
  }

  function toggleFilterValues(button){
    const listId=button.getAttribute('aria-controls');
    const list=listId?document.getElementById(listId):null;
    if(!list)return;
    const expanded=button.getAttribute('aria-expanded')==='true';
    list.querySelectorAll('[data-filter-extra]').forEach((item)=>{
      if(expanded&&!item.querySelector('input:checked'))item.hidden=true;
      else item.hidden=false;
    });
    button.setAttribute('aria-expanded',expanded?'false':'true');
    const label=button.querySelector('[data-filter-toggle-label]');
    if(label)label.textContent=expanded?'Show more':'Show less';
  }

  function hasExpectedProductCardMarkup(replacement){
    const grid=replacement.querySelector('.collection-product-grid');
    if(!grid||grid.children.length===0)return true;
    return Boolean(grid.querySelector('.product-card__media img'));
  }

  function scrollToDisneyResults(){
    const root=section();
    const target=root?.querySelector('.collection-page__heading')||root;
    if(!target)return;
    const top=target.getBoundingClientRect().top+window.scrollY-110;
    window.scrollTo({top:Math.max(0,top),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  }

  function showDisneyLoading(){
    const results=section()?.querySelector('[data-collection-results]');
    if(!results)return;
    results.classList.add('disney-results-loading');
    results.querySelector('.disney-loading-state')?.remove();
    const loader=document.createElement('div');
    loader.className='disney-loading-state';
    loader.setAttribute('role','status');
    loader.setAttribute('aria-live','polite');
    const spinner=document.createElement('span');
    spinner.className='disney-loading-spinner';
    spinner.setAttribute('aria-hidden','true');
    const label=document.createElement('span');
    label.textContent=disneyNav()?.getAttribute('dir')==='rtl'?'جارٍ تحديث الألعاب…':'Updating toys…';
    loader.append(spinner,label);
    results.prepend(loader);
  }

  function clearDisneyLoading(){
    const results=section()?.querySelector('[data-collection-results]');
    results?.classList.remove('disney-results-loading');
    results?.querySelector('.disney-loading-state')?.remove();
  }

  function showDisneyError(){
    const root=section();
    if(!root)return;
    root.querySelector('.disney-filter-error')?.remove();
    const notice=document.createElement('p');
    notice.className='disney-filter-error';
    notice.setAttribute('role','alert');
    notice.textContent=disneyNav()?.getAttribute('dir')==='rtl'
      ?'تعذّر تحديث المنتجات. يرجى المحاولة مرة أخرى.'
      :'We couldn\'t update these products. Please try again.';
    root.querySelector('.collection-toolbar')?.after(notice);
  }

  async function fetchDisneyCollectionHtml(sourceUrl,sectionId,controller,isDisney){
    const primaryId=sectionId;
    const fetchUrl=new URL(sourceUrl.href);
    fetchUrl.searchParams.delete('section_id');
    fetchUrl.searchParams.set('sections',primaryId);
    const options={headers:{Accept:'application/json'},signal:controller.signal,credentials:'same-origin'};
    let html=null;
    try{
      const response=await fetch(fetchUrl.href,options);
      if(response.ok){
        const data=await response.json();
        html=data?.[primaryId]||null;
      }
    }catch(error){
      if(error.name==='AbortError')throw error;
    }
    if(html&&html.includes('data-collection-section'))return html;
    if(!isDisney)throw new Error('Collection section was not returned');

    const fallbackUrl=new URL(sourceUrl.href);
    fallbackUrl.searchParams.delete('sections');
    fallbackUrl.searchParams.set('section_id','main-collection');
    const response=await fetch(fallbackUrl.href,{headers:{Accept:'text/html'},signal:controller.signal,credentials:'same-origin'});
    if(!response.ok)throw new Error('Shopify collection fallback was not returned');
    html=await response.text();
    if(!html.includes('data-collection-section'))throw new Error('Shopify returned no collection markup');
    return html;
  }

  async function renderCollection(target,{push=true,scroll=false}={}){
    const current=section();
    if(!current)return;
    const isDisney=Boolean(disneyNav());
    const sectionId=isDisney&&current.dataset.disneySectionId
      ?current.dataset.disneySectionId
      :current.dataset.sectionId;
    const request=resolveDisneyCollection(target);
    const publicUrl=request.publicUrl;
    const fetchId=request.selected?'main-collection':sectionId;

    requestController?.abort();
    const controller=new AbortController();
    requestController=controller;
    current.querySelector('.disney-filter-error')?.remove();
    loading(true);
    if(isDisney){
      if(scroll)scrollToDisneyResults();
      showDisneyLoading();
    }

    try{
      const html=await fetchDisneyCollectionHtml(request.sourceUrl,fetchId,controller,isDisney);
      if(requestController!==controller)return;
      const parsed=new DOMParser().parseFromString(html,'text/html');
      const replacement=parsed.querySelector('[data-collection-section]');
      if(!replacement)throw new Error('Collection section markup was not found');
      if(!hasExpectedProductCardMarkup(replacement))throw new Error('Collection response came from an incompatible theme');

      if(isDisney){
        placeDisneySeoAfterProducts(replacement);
        replacement.dataset.disneySectionId=sectionId;
        replacement.dataset.sectionId=sectionId;
        replacement.id='disney-products';
        replacement.querySelector('.collection-breadcrumb')?.remove();
        if(request.selected)replacement.querySelectorAll('.collection-page__seo-content,.collection-page__description').forEach((el)=>el.remove());
      }

      current.replaceWith(replacement);
      setBodyLock(false);
      if(!request.selected)promoteDescriptionBanner();
      if(push)window.history.pushState({},'',publicUrl.href);
      updateDisneyFilterState(publicUrl,replacement);
      if(scroll&&!isDisney){
        const toolbar=replacement.querySelector('.collection-toolbar');
        const top=(toolbar?.getBoundingClientRect().top||replacement.getBoundingClientRect().top)+window.scrollY-110;
        window.scrollTo({top:Math.max(0,top),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      }
    }catch(error){
      if(error.name==='AbortError')return;
      if(isDisney){
        showDisneyError();
        console.warn('Disney collection filter failed:',error);
      }else{
        window.location.assign(publicUrl.href);
      }
    }finally{
      if(requestController===controller){
        loading(false);
        if(isDisney)clearDisneyLoading();
        requestController=null;
      }
    }
  }

  function submitCollectionForm(form,{scroll=false}={}){
    renderCollection(formUrl(form),{push:true,scroll});
  }

  function focusables(panel){
    return [...panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter((el)=>!el.hasAttribute('hidden'));
  }

  document.addEventListener('submit',(event)=>{
    const filterForm=event.target.closest('[data-collection-filter-form]');
    if(filterForm){
      event.preventDefault();
      submitCollectionForm(filterForm,{scroll:true});
      return;
    }
    const sortForm=event.target.closest('[data-collection-sort-form]');
    if(sortForm){
      event.preventDefault();
      submitCollectionForm(sortForm,{scroll:true});
    }
  });

  document.addEventListener('change',(event)=>{
    if(event.target.matches('[data-sort-select]')){
      event.target.form?.requestSubmit();
      return;
    }

    const desktopForm=event.target.closest('.collection-sidebar [data-collection-filter-form]');
    if(desktopForm&&event.target.matches('input[type="checkbox"]')){
      window.clearTimeout(desktopFilterTimer);
      desktopFilterTimer=window.setTimeout(()=>submitCollectionForm(desktopForm,{scroll:false}),220);
    }
  });

  document.addEventListener('click',(event)=>{
    const filterToggle=event.target.closest('[data-filter-values-toggle]');
    if(filterToggle){event.preventDefault();toggleFilterValues(filterToggle);return;}

    const opener=event.target.closest('[data-filter-drawer-open]');
    if(opener){event.preventDefault();openFilters(opener);return;}

    const closer=event.target.closest('[data-filter-drawer-close]');
    if(closer){event.preventDefault();closeFilters();return;}

    const character=event.target.closest('[data-disney-character-source]');
    const nav=disneyNav();
    if(character&&nav){
      const destination=new URL(character.dataset.disneyCharacterSource,window.location.origin);
      if(destination.origin===window.location.origin){
        event.preventDefault();
        const url=new URL(nav.dataset.disneyBaseUrl,window.location.origin);
        url.searchParams.set('view','disney');
        const key=character.dataset.disneyCharacterKey;
        const current=new URL(window.location.href).searchParams.get('disney_character');
        if(key&&current!==key)url.searchParams.set('disney_character',key);
        renderCollection(preserveThemeContext(url),{push:true,scroll:true});
        return;
      }
    }

    const link=event.target.closest('[data-collection-link]');
    if(link&&link.href){
      const url=new URL(link.href,window.location.origin);
      if(url.origin===window.location.origin){
        event.preventDefault();
        renderCollection(url,{push:true,scroll:true});
      }
    }
  });

  document.addEventListener('keydown',(event)=>{
    const drawer=filterDrawer();
    if(!drawer?.classList.contains('is-open'))return;
    if(event.key==='Escape'){event.preventDefault();closeFilters();return;}
    if(event.key!=='Tab')return;
    const panel=drawer.querySelector('.collection-filter-drawer__panel');
    const items=panel?focusables(panel):[];
    if(!items.length)return;
    const first=items[0];
    const last=items[items.length-1];
    if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
    else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
  });

  window.addEventListener('popstate',()=>renderCollection(window.location.href,{push:false,scroll:false}));

  function initializeCollection(){
    const firstSection=section();
    if(disneyNav()&&firstSection){
      firstSection.dataset.disneySectionId=firstSection.dataset.sectionId;
      placeDisneySeoAfterProducts(firstSection);
    }
    promoteDescriptionBanner();
    const nav=disneyNav();
    if(!nav)return;
    const initial=new URL(window.location.href);
    if(initial.searchParams.has('disney_character')){
      renderCollection(initial,{push:false,scroll:false});
    }else{
      updateDisneyFilterState(initial,section());
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initializeCollection,{once:true});
  else initializeCollection();
})();